export const cruisesLineAu = [
  {
    text: "All Cruise Lines",
    value: "-99",
  },
  {
    text: "American Queen Steamboat",
    value: "171",
  },
  {
    text: "APT - Australian Pacific Touring",
    value: "139",
  },
  {
    text: "Avalon Waterways AU",
    value: "84",
  },
  {
    text: "Azamara Club",
    value: "116",
  },
  {
    text: "Blue Lagoon AU",
    value: "89",
  },
  {
    text: "Captain Cook",
    value: "38",
  },
  {
    text: "Carnival Cruise Lines",
    value: "1",
  },
  {
    text: "Carnival Cruise Lines [AU/NZ]",
    value: "164",
  },
  {
    text: "Celebrity",
    value: "6",
  },
  {
    text: "Costa",
    value: "7",
  },
  {
    text: "Crystal",
    value: "14",
  },
  {
    text: "Disney",
    value: "9",
  },
  {
    text: "Dream AU",
    value: "259",
  },
  {
    text: "G Adventures",
    value: "155",
  },
  {
    text: "Holland America",
    value: "3",
  },
  {
    text: "Lindblad Expeditions AU",
    value: "210",
  },
  {
    text: "MSC Cruises AU",
    value: "83",
  },
  {
    text: "Norwegian",
    value: "8",
  },
  {
    text: "Oceania Cruises",
    value: "58",
  },
  {
    text: "P&amp;O Cruises Australia",
    value: "104",
  },
  {
    text: "Ponant AU",
    value: "214",
  },
  {
    text: "Princess Cruises",
    value: "2",
  },
  {
    text: "Regent Seven Seas",
    value: "15",
  },
  {
    text: "Royal Caribbean",
    value: "4",
  },
  {
    text: "Seabourn",
    value: "21",
  },
  {
    text: "Silversea",
    value: "17",
  },
  {
    text: "Star",
    value: "40",
  },
  {
    text: "Travelmarvel",
    value: "200",
  },
  {
    text: "U by Uniworld AU",
    value: "275",
  },
  {
    text: "Viking AU",
    value: "130",
  },
  {
    text: "Windstar",
    value: "24",
  },
];
